import { createFileRoute } from "@tanstack/react-router";

import MyCardsPanel from "../components/MyCardsPanel";

export const Route = createFileRoute("/profile/cards")({
  component: MyCardsPanel,
});
